export const texts = {
  active: "pt-br",
  ["pt-br"]: {
    title: "Morfos Tecnologia – Sistemas, Consultoria e Automação",
    nav: {
      it1: "Home",
      it2: "Serviços",
      it3: "Portfólio",
      it4: "Depoimentos",
      it5: "Conquistas",
      it6: "Contato",
    },
    home: {
      h1: "Sistemas Inteligentes para Desafios Reais.",
      h3: "Desenvolvimento, automação e consultoria com foco em eficiência e escalabilidade.",
      span1: "Converse com o nosso time no whatsapp.",
      btn1: "Solicitar Proposta",
      btn2: "Ver Vídeo",
    },
    services: {
      div: "SERVIÇOS",
      h1: "Consultoria de sistemas e gestão da informação",
      h3: "Descubra como ajudamos outras empresas a crescerem com soluções personalizadas.",

      features: [
        {
          title: "Diagnóstico de sistemas",
          text: "Levantamento de necessidades e problemas atuais.",
          icon: "zap",
        },
        {
          title: "Desenvolvimento sob demanda",
          text: "Planejamento técnico e desenvolvimento de sistemas e websites personalizados.",
          icon: "code",
        },
        {
          title: "Integração de Sistemas",
          text: "Fazer com que sistemas diferentes se comuniquem.",
          icon: "server",
        },

        {
          title: "Aplicativos Mobile Personalizados",
          text: "Tenha um app próprio para sua empresa, acessível no Android e iOS, conectado ao sistema web.",
          icon: "smartphone",
        },
        {
          title: "Dashboards Interativos e Relatórios",
          text: "Visualize os principais dados da sua empresa com gráficos dinâmicos e relatórios exportáveis.",
          icon: "pie-chart",
        },
        {
          title: "Sistemas Inteligentes de Atendimento",
          text: "Automatize o atendimento ao cliente com bots inteligentes e integrações com WhatsApp, e-mail ou chat no site.",
          icon: "message-circle",
        },
      ],
    },
    works: {
      div: "PORTFÓLIO",
      h1: "Algumas das nossas criações",
      h3: "Inspire-se com os sistemas e apps que desenvolvemos para clientes como você.",
      btn1: "Ver Projetos",
    },
    achievements: {
      div: "CONQUISTAS",
      h1: "Um Time Campeão",
      h3: "Nossa equipe é destaque em uma das maiores plataformas de freelancers da América Latina. São mais de 7 milhões de profissionais cadastrados — e a Morfos alcançou a 3ª posição no Ranking Global.",
    },
    testimonials: {
      div: "DEPOIMENTOS",
      h1: "Eles gostaram e aprovaram",
      h3: "Confira o que estão dizendo sobre a Morfos",
      speechs: [
        {
          work: "Aplicativo para recomendações.",
          client: "Michel Rodrigues",
          speech:
            "Profissionais responsáveis e dedicados, que realizam as entregas de acordo com a expectativa do cliente.",
        },
        {
          work: "Aprimoramento de recursos do app web.",
          client: "Mateus Matos",
          speech:
            "Parceria forte entre nós e a Morfos: muita qualidade e clareza no trabalho. Escolha mais que acertada.",
        },
        {
          work: "Layout mobile.",
          client: "Adriano Andrade",
          speech:
            "Atendeu a todas as minhas expectativas. Super profissionais!",
        },
        {
          work: "App para divulgação e comercialização de produtos agrícolas.",
          client: "Axel Jeferson",
          speech:
            "Demonstraram um trabalho de qualidade, além de terem uma ótima compreensão dos pedidos e ajustes feitos, conseguindo atingir com destreza tudo o que foi solicitado por mim. Além disso, possuem um atendimento frequente e de fácil acesso, permitindo que o acompanhamento seja fácil e sem empecilhos.",
        },
        {
          work: "Desenvolvimento: app na parte web + novos itens no código mobile.",
          client: "Elmiro Nicolau da Silva Filho",
          speech:
            "Profissionais com alto comprometimento, que trabalham com qualidade e agilidade.",
        },
        {
          work: "Desenvolvimento de aplicativo - HugU.",
          client: "Eliezer Manoel",
          speech:
            "Dedicados, comprometidos e minuciosamente atenciosos com o projeto ou ideia do cliente. Uma equipe pra lá de profissional.",
        },
      ],
    },
    contact: {
      title: "Como podemos te ajudar?",
      subtitle: "Escolha o tipo de atendimento:",
      h3A: "Para Minha Empresa",
      span1: "Quero um sistema sob medida",

      h3B: "Outros Assuntos",
      span2: "Tenho dúvidas ou outro tipo de solicitação",

      btn1: "Solicitar Proposta",
      btn2: "Solicitar Atendimento",
    },
    footer: {
      txt1: "111",
      txt2: "222",
      txt3: "333",
      sections: [
        {
          title: "Contato",
          texts: [
            "São Paulo, Br",
            "Horário de atendimento é de segunda a sexta-feira, das 9h às 17h (GMT-3, horário de Brasília)",
          ],
          links: [
            {
              view: "[clique aqui] para conversar com o nosso time",
              type: "show_modal",
              // url: "https://api.whatsapp.com/send?phone=5511916745093&text=Ol%C3%A1%2C+vi+seu+an%C3%BAncio+no+Google+e+quero+mais+informa%C3%A7%C3%B5es+sobre+o+desenvolvimento+de+software.",
            },
          ],
        },
        {
          title: "Quem Somos",
          texts: [],
          links: [
            { view: "Home", url: "#Home", target: "_self" },
            { view: "Serviços", url: "#Serviços", target: "_self" },
            { view: "Portfólio", url: "#Trabalhos", target: "_self" },
            { view: "Depoimentos", url: "#Depoimentos", target: "_self" },
            { view: "Conquistas", url: "#Conquistas", target: "_self" },
            {
              view: "Contato",
              type: "show_modal",
            },
          ],
        },
        {
          title: "Conexões",
          texts: [],
          links: [
            {
              view: "Workana",
              url: "https://www.workana.com/freelancer/0846213fc5b9ee1a5035f9366206344c",
              target: "_blank",
            },

            {
              view: "Grupo no Whatsapp",
              url: "https://chat.whatsapp.com/CP1nIFrpvW168jAde56K5U",
              target: "_blank",
            },
          ],
        },
        {
          title: "FLAXBOLL",
          texts: ["Nossa poderosa plataforma online de criação de APPs."],
          links: [
            { view: "Criar", url: "https://flaxboll.io", target: "_blank" },
            {
              view: "Explorar",
              url: "https://flaxboll.io/ui-ux/models",
              target: "_blank",
            },
            {
              view: "Cursos",
              url: "https://hotmart.com/pt-br/marketplace/produtos/programacao-descomplicada-suporte-vip-flaxboll/F99178280Q",
              target: "_blank",
            },
            {
              view: "Aprender",
              url: "https://www.youtube.com/@flaxboll-brasil",
              target: "_blank",
            },
          ],
        },
        {
          title: "Social",
          texts: [],
          links: [
            {
              view: "Facebook",
              url: "https://www.facebook.com/morfosweb",
              target: "_blank",
            },
            {
              view: "Discord",
              url: "https://discord.com/invite/FJaMBWYgwh",
              target: "_blank",
            },
            {
              view: "LinkedIn",
              url: "https://www.linkedin.com/company/morfos-web/",
              target: "_blank",
            },
            {
              view: "Youtube",
              url: "https://www.youtube.com/@flaxboll-brasil",
              target: "_blank",
            },
            { view: "X", url: "https://x.com/_flaxboll_br", target: "_blank" },
          ],
        },
      ],
    },
  },
  en: {
    title: "Morfos Technology – Systems, Consulting, and Automation",
    nav: {
      it1: "Home",
      it2: "Services",
      it3: "Works",
      it4: "Contact",
    },
    home: {
      h1: "Sistemas Inteligentes para Desafios Reais.",
      h3: "Desenvolvimento, automação e consultoria com foco em eficiência e escalabilidade.",
      btn1: "Solicitar Proposta",
      btn2: "Ver Vídeo",
    },
    services: {
      div: "SERVIÇOS",
      h1: "Consultoria de sistemas e gestão da informação",
      h3: "Descubra como ajudamos outras empresas a crescerem com soluções personalizadas.",

      features: [
        {
          title: "Diagnóstico de sistemas",
          text: "Levantamento de necessidades e problemas atuais.",
          icon: "zap",
        },
        {
          title: "Desenvolvimento sob demanda",
          text: "Planejamento técnico e desenvolvimento de sistemas personalizados.",
          icon: "code",
        },
        {
          title: "Integração de Sistemas",
          text: "Fazer com que sistemas diferentes se comuniquem.",
          icon: "server",
        },
      ],
    },
    works: {
      div: "PORTFÓLIO",
      h1: "Algumas das nossas criações",
      h3: "Inspire-se com os sistemas e apps que desenvolvemos para clientes como você.",
      btn1: "Ver Projetos",
    },
    achievements: {
      div: "CONQUISTAS",
      h1: "Um Time Campeão",
      h3: "Nossa equipe é destaque em uma das maiores plataformas de freelancers da América Latina. São mais de 7 milhões de profissionais cadastrados — e a Morfos está no Top 1% global.",
    },
    testimonials: {
      div: "DEPOIMENTOS",
      h1: "Eles gostaram e aprovaram",
      h3: "Confira o que estão dizendo sobre a Morfos",
      speechs: [
        {
          work: "Aplicativo para recomendações",
          client: "Michel Rodrigues",
          speech:
            "Profissionais responsáveis e dedicados para realizar as entregas de acordo com a expectativa do cliente.",
        },
        {
          work: "Aprimoramento Recursos App web",
          client: "Mateus Matos",
          speech:
            "Parceria forte entre nós e a Morfos, muita qualidade e clareza no trabalho. Escolha mais que acertada.",
        },
        {
          work: "Etapa Morfos Layout Mobile",
          client: "Adriano Andrade",
          speech: "Atendeu todas as minhas expectativas! Super profissionais!",
        },
        {
          work: "App para Divulgação e Comercialização de produtos agrícolas",
          client: "Axel Jeferson",
          speech:
            "Demonstraram um trabalho de qualidade além de terem uma ótima compreensão relacionada aos pedidos feitos e ajustes, conseguindo atingir com destreza o que foi pedido por mim. Além disso possuem um atendimento frequente e de fácil acesso permitindo que o acompanhamento se torne fácil e sem empecilhos.",
        },
        {
          work: "Desenvolvimento (app na parte web + novos itens no código mobile)",
          client: "Elmiro Nicolau da Silva Filho",
          speech:
            "Profissionais com alto comprometimento. Trabalham com qualidade e agilidade.",
        },
        {
          work: "Desenvolvimento de aplicativo - Hug.u",
          client: "Eliezer Manoel",
          speech:
            "Dedicados, comprometidos e minunciosamente atenciosos com o projeto ou ideia do cliente, uma equipe pra lá de profissional.",
        },
      ],
    },
    footer: {
      txt1: "111",
      txt2: "222",
      txt3: "333",
      sections: [
        {
          title: "Contato",
          texts: [
            "Horário de atendimento é de segunda a sexta-feira, das 9h às 17h (GMT-3, horário de Brasília)",
            "+55 11 91674-5093",
            "São Paulo, Br",
          ],
          links: [],
        },
        {
          title: "Quem Somos",
          texts: [],
          links: [
            { view: "Home", url: "#Home", target: "_self" },
            { view: "Serviços", url: "#Serviços", target: "_self" },
            { view: "Portfólio", url: "#Trabalhos", target: "_self" },
            { view: "Depoimentos", url: "#Depoimentos", target: "_self" },
            {
              view: "Contato",
              type: "show_modal",
            },
          ],
        },
        {
          title: "Conexões",
          texts: [],
          links: [
            {
              view: "Workana",
              url: "https://www.workana.com/freelancer/0846213fc5b9ee1a5035f9366206344c",
              target: "_blank",
            },

            {
              view: "Cursos",
              url: "https://hotmart.com/pt-br/marketplace/produtos/programacao-descomplicada-suporte-vip-flaxboll/F99178280Q",
              target: "_blank",
            },

            {
              view: "Novidades",
              url: "https://chat.whatsapp.com/CP1nIFrpvW168jAde56K5U",
              target: "_blank",
            },
          ],
        },
        {
          title: "Builder",
          texts: [],
          links: [
            {
              view: "Explorar",
              url: "https://flaxboll.io/ui-ux/models",
              target: "_blank",
            },
            {
              view: "Aprender",
              url: "https://www.youtube.com/@flaxboll-brasil",
              target: "_blank",
            },
            { view: "Criar", url: "https://flaxboll.io", target: "_blank" },
          ],
        },
        {
          title: "Social",
          texts: [],
          links: [
            {
              view: "Facebook",
              url: "https://www.facebook.com/flaxboll",
              target: "_blank",
            },
            {
              view: "Discord",
              url: "https://discord.com/invite/FJaMBWYgwh",
              target: "_blank",
            },
            {
              view: "LinkedIn",
              url: "https://www.linkedin.com/company/morfos-web/",
              target: "_blank",
            },
            { view: "X", url: "https://x.com/_flaxboll_br", target: "_blank" },
          ],
        },
      ],
    },
  },
};
